<script lang="ts" setup>
import AppModal from '~theme/components/atoms/AppModal.vue';
import PinchImageBox from '~theme/components/molecules/PinchImageBox.vue';

defineProps<{
  src: string;
  alt?: string;
}>();

const id = useId();
const keyName = `PinchImageModal${id}`;
const { ControlledModal, openModal } = useModalUnnamed(keyName, AppModal);
</script>

<template>
  <div :class="$style.container" @click="openModal()">
    <img :src="src" :alt="alt" />
    <ControlledModal>
      <PinchImageBox :src="src" :class="$style.imageBox" />
    </ControlledModal>
  </div>
</template>

<style lang="scss" module>
.imageBox {
  height: 100%;
  width: 100%;
}
</style>
